import { stringify } from 'qs';
import request from '../../../../../services/request';
import { url } from '../service-utils';

/**
 * 获取可以匹配的字段列表
 * 页面：学生导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function getMatchTitleList(params) {
  return request(`${url.url}/internal/v2/templateMatch/getMatchTitle?${stringify(params)}`);
}

/**
 * 保存表头匹配结果
 * 页面：学生导入
 * 前端：刘杰
 * 后端：夏劲峰
 */
export async function saveMatchTitle(params) {
  return request(`${url.url}/internal/v2/templateMatch/saveMatchTitle`, {
    method: 'post',
    data: params,
  });
}
